import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL
}
const headers = {
  Authorization: localStorage.getItem('access_token'),
  AuthId: localStorage.getItem('id_token'),
  SiigoAuth: localStorage.getItem('siigo_token'),
}

export function* getCajas() {
  const res = yield gaxios.request({
    url: 'api/caja',
    headers
  });
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    yield put({
      type: actions.GET_CAJAS_SUCCESS,
      payload: res.data.cajas,
    });
  }
}
export function* createTraslado({ payload, history }) {
  const res = yield gaxios.request({
    url: 'api/caja/traslado',
    method: 'POST',
    data: { ...payload, tipo: "Traslado", esContadorPrueba: process.env.NODE_ENV === 'development' ? true : false },
    headers
  });
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    notification('success', res.data.msg);
    yield history.push('lista-recibos');
  }
}
export function* editCaja({ payload }) {
  const res = yield gaxios.request({
    url: 'api/caja/' + payload._id,
    method: 'PUT',
    data: payload,
    headers
  });
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    notification('success', res.data.msg);
    yield put({ type: actions.EDIT_CAJA_SUCCESS, payload: res.data.caja });
  }
}

/*RECIBOS */

export function* saveReciboSaga(action) {
  let ULRDestino = "api/caja/recibo/";
  action.recibo.cajero = localStorage.getItem('id_token');
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    data: { ...action.recibo, esContadorPrueba: process.env.NODE_ENV === 'development' ? true : false },
    method: metodo,
    headers
  });
  if (res.data.success) {
    yield put({
      type: actions.GET_RECIBOS,
    });
    notification('success', res.data.msg);
    yield action.history.push('lista-recibos');
  } else {
    notification('error', res.data.msg);
  }
}

export function* getRecibosSaga(action) {
  let ULRDestino = `api/caja/recibo/${action.query ? "?" + action.query : ""}`;
  let metodo = "GET";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    headers
  });
  yield put({
    type: actions.UPDATE_RECIBOS,
    payload: res.data.recibos,
  });
  if (res.data.paginationInfo) {
    yield put({
      type: actions.SET_PAGINATION_INFO,
      payload: res.data.paginationInfo,
    });
  }
}

export function* deleteRecibo(action) {
  let ULRDestino = "api/caja/recibo/" + action.id;
  let metodo = "DELETE";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    headers
  });
  if (res.data.success) {
    notification('success', res.data.msg)
    yield put({
      type: actions.GET_RECIBOS,
    });
  } else {
    notification('error', res.data.msg);
  }
}

export function* updateRecibo(action) {
  let ULRDestino = "api/caja/recibo/" + action.id;
  let metodo = "PUT";
  const res = yield gaxios.request({
    url: ULRDestino,
    data: action.info,
    method: metodo,
    headers
  });
  if (res.data.success) {
    notification('success', res.data.msg)
    yield put({
      type: actions.GET_RECIBOS,
    });
  } else {
    notification('error', res.data.msg);
  }
}

/*EGRESOS */

export function* saveEgresoSaga(action) {
  let ULRDestino = "api/caja/egresos/";
  action.egreso.cajero = localStorage.getItem('id_token');
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    data: { ...action.egreso, esContadorPrueba: process.env.NODE_ENV === 'development' ? true : false },
    method: metodo,
    headers
  });
  if (res.data.success) {
    yield put({
      type: actions.GET_EGRESOS,
    });
    notification('success', res.data.msg);
    yield action.history.push('lista-egresos');
  } else {
    notification('error', res.data.msg);
  }
}

export function* getEgresosSaga(action) {
  let ULRDestino = `api/caja/egresos/${action.query ? "?" + action.query : ""}`;
  let metodo = "GET";
  console.log("aca")
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    headers
  });
  yield put({
    type: actions.UPDATE_EGRESOS,
    payload: res.data.egresos,
  });

  if (res.data.paginationInfo) {
    yield put({
      type: actions.SET_PAGINATION_EGRESOS_INFO,
      payload: res.data.paginationInfo,
    });
  }
}

export function* deleteEgreso(action) {
  let ULRDestino = "api/caja/egresos/" + action.id;
  let metodo = "DELETE";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    headers
  });
  if (res.data.success) {
    notification('success', res.data.msg)
    yield put({
      type: actions.GET_RECIBOS,
    });
  } else {
    notification('error', res.data.msg);
  }
}

export function* updateEgreso(action) {
  let ULRDestino = "api/caja/egresos/" + action.id;
  let metodo = "PUT";
  const res = yield gaxios.request({
    url: ULRDestino,
    data: action.info,
    method: metodo,
    headers
  });
  if (res.data.success) {
    notification('success', res.data.msg);
    yield put({
      type: actions.GET_EGRESOS,
    });
  } else {
    notification('error', res.data.msg);
  }
}


export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_CAJAS_REQUEST, getCajas),
    yield takeEvery(actions.CREATE_TRASLADO_REQUEST, createTraslado),
    yield takeEvery(actions.EDIT_CAJA_REQUEST, editCaja),

    yield takeEvery(actions.SAVE_RECIBO, saveReciboSaga),
    yield takeEvery(actions.GET_RECIBOS, getRecibosSaga),
    yield takeEvery(actions.DELETE_RECIBO, deleteRecibo),
    yield takeEvery(actions.UPDATE_RECIBO, updateRecibo),

    yield takeEvery(actions.SAVE_EGRESO, saveEgresoSaga),
    yield takeEvery(actions.GET_EGRESOS, getEgresosSaga),
    yield takeEvery(actions.DELETE_EGRESO, deleteEgreso),
    yield takeEvery(actions.UPDATE_EGRESO, updateEgreso),
  ]);
}
